import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7194ac20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mas-table" }
const _hoisted_2 = { class: "table-tool-bar" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = {
  key: 0,
  class: "selected-tip"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 批量操作 | 已选择 ")
const _hoisted_6 = { class: "number" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 条记录 ")
const _hoisted_8 = { class: "right" }

import { ElTable } from "element-plus";
import { PropType, ref, onMounted, useSlots } from "vue";
import { IPageConfig } from "./type";

const __default__ = {
  name: "MasTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  selectedNum: {
    type: Number || String,
    default: 0,
  },
  stripe: {
    type: Boolean,
    default: true,
  },
  maxHeight: {
    type: String || Number,
    default: "500",
  },
  // 是否显示分页
  showPagination: {
    type: Boolean,
    default: true,
  },
  pageConfig: {
    type: Object as () => IPageConfig,
    default: {},
  },
  // 每页数据的选项
  pageSizes: {
    type: Array as PropType<number[]>,
    default: [10, 20, 30, 40, 50, 100, 200],
  },
  paginationAlign: {
    type: String as PropType<"left" | "center" | "right">,
    default: "right",
  },
  // 当只有一页时，通过设置 hide-on-single-page 属性来隐藏分页。
  hideOnSinglePage: {
    type: Boolean as PropType<true | false>,
    default: false,
  },
},
  setup(__props, { expose }) {

const props = __props

const elTableRef = ref<InstanceType<typeof ElTable>>();
const showSelectedTip = ref<Boolean>(false);
const slots = useSlots();



const paginationAlignJustify = () => {
  if (props.paginationAlign === "left") {
    return "flex-start";
  } else if (props.paginationAlign === "center") {
    return "flex-center";
  } else if (props.paginationAlign === "right") {
    return "flex-end";
  }
};

onMounted(() => {
  // console.error('slots',slots)
  showSelectedTip.value = slots.default().some((el) => el?.props?.type === "selection");
});
expose({
  elTableRef,
});

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (showSelectedTip.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.selectedNum), 1),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "tool-left")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "tool-right")
      ])
    ]),
    _createVNode(_unref(ElTable), _mergeProps({
      ref_key: "elTableRef",
      ref: elTableRef,
      stripe: "",
      "header-row-class-name": "header-row-class-name",
      "max-height": __props.maxHeight
    }, _ctx.$attrs.tableAttrs, _toHandlers(_ctx.$attrs.tableListeners)), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["max-height"]),
    (__props.showPagination)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "pagination",
          style: _normalizeStyle({ justifyContent: paginationAlignJustify() })
        }, [
          _createVNode(_component_el_pagination, _mergeProps({
            layout: "total, sizes, prev, pager, next, jumper",
            "hide-on-single-page": __props.hideOnSinglePage,
            "page-sizes": __props.pageSizes,
            total: __props.pageConfig.total,
            "current-page": __props.pageConfig.current,
            "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((__props.pageConfig.current) = $event)),
            "page-size": __props.pageConfig.pageSize,
            "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((__props.pageConfig.pageSize) = $event))
          }, _ctx.$attrs.paginationAttrs, _toHandlers(_ctx.$attrs.paginationListeners)), null, 16, ["hide-on-single-page", "page-sizes", "total", "current-page", "page-size"])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})